// extracted by mini-css-extract-plugin
export default {"siteFooter":"footer-siteFooter-yOwiOX","hide":"footer-hide-xpzumT","about":"footer-about-suZOiB","submitAnIssue":"footer-submitAnIssue-tqgGZs"};